import { InfiniteLoaderItemProps } from '@hqo/react-components-library/dist/molecules/infinite-loader';
import React from 'react';
import { VisitUiType } from 'store/visits/types';
import { LinkContent, WrapperLink } from './visit-item.styles';
import { generatePath, useParams } from 'react-router-dom';
import { ROOT_PATH, VISITS_SUB_PATH } from 'shared/consts';
import { OwnerParams } from 'shared/types';

interface VisitItemProps extends InfiniteLoaderItemProps {
  type: VisitUiType;
  children: React.ReactNode;
  visitId: string;
}

export const VisitDetailsLink = ({ style, type, children, visitId }: VisitItemProps): JSX.Element => {
  const { ownerId, ownerType } = useParams<OwnerParams>();
  const visitPage = `${generatePath(`${ROOT_PATH}/${VISITS_SUB_PATH}`, { ownerId, ownerType })}/${type}/${visitId}`;

  return (
    <WrapperLink style={style} data-cy="visit-card" to={visitPage}>
      <LinkContent>{children}</LinkContent>
    </WrapperLink>
  );
};
